export default __webpack_public_path__ + "static/media/Lightsaber Obi-Wan ANH - Img - Wip 3_00.d3e0cbef.jpg";